import * as React from 'react'
import { DownTime } from '../../model/DownTime'
import { DownTimeAction } from '../../model/DownTimeEnums'
import { Dropdown, Tooltip } from 'react-bootstrap'
import { OverlayTrigger } from 'react-bootstrap'
import { FaExclamation } from 'react-icons/fa'

type Props = {
  downTime: DownTime
  onInfoSplit(downTime: DownTime): void
  onCopy(downTime: DownTime): void
  onRevert(downTime: DownTime): void
  onSave(downTime: DownTime): void
  checkCanEditTimeOff(downTime: DownTime): void
}

export class DownTimeActionsButton extends React.Component<Props> {
  readonly failedActionOverlays: Record<DownTimeAction, JSX.Element> = {
    [DownTimeAction.save]: (
      <Tooltip id={'failed-save-tooltip'}>
        <strong>Save failed</strong>
        <br />
        Try saving again in this dropdown
        <br />
        Editing downtime will auto save again
      </Tooltip>
    ),
    [DownTimeAction.revert]: (
      <Tooltip id={'failed-save-tooltip'}>
        <strong>Revert failed</strong>
        <br />
        Try reverting again
      </Tooltip>
    ),
    [DownTimeAction.copy]: (
      <Tooltip id={'failed-save-tooltip'}>
        <strong>Copy failed</strong>
        <br />
        Try copying again
      </Tooltip>
    ),
    [DownTimeAction.split]: (
      <Tooltip id={'failed-save-tooltip'}>
        <strong>Split failed</strong>
        <br />
        Try splitting again
      </Tooltip>
    )
  }

  renderDropDownActions = (): JSX.Element => {
    const { downTime } = this.props
    return (
      <Dropdown.Menu className="dropdown-menu-right">
        <Dropdown.Item key="info" onClick={() => this.props.onInfoSplit(downTime)}>
          Info / Split
        </Dropdown.Item>
        <Dropdown.Item key="copy" onClick={() => this.props.onCopy(downTime)}>
          Copy
        </Dropdown.Item>
        {this.props.downTime.Edited() && (
          <Dropdown.Item key="revert" onClick={() => this.props.onRevert(downTime)}>
            Revert
          </Dropdown.Item>
        )}
        {downTime.canEditTimeOff === undefined && (
          <Dropdown.Item key="edit" onClick={() => this.props.checkCanEditTimeOff(downTime)}>
            Edit Time Off
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    )
  }

  renderFailedSaveDropDownActions = (): JSX.Element => {
    return (
      <Dropdown.Menu className="dropdown-menu-right">
        <Dropdown.Item key="info" onClick={() => this.props.onSave(this.props.downTime)}>
          Retry Save
        </Dropdown.Item>
      </Dropdown.Menu>
    )
  }

  renderDropDown = (): JSX.Element => {
    return (
      <Dropdown id="downtime-options">
        <Dropdown.Toggle
          id="downtime-options-toggle"
          variant={this.props.downTime.failedAction ? 'danger' : 'primary'}
        >
          {this.props.downTime.failedAction && <FaExclamation />}
        </Dropdown.Toggle>

        {this.props.downTime.failedAction &&
        this.props.downTime.failedAction.action === DownTimeAction.save
          ? this.renderFailedSaveDropDownActions()
          : this.renderDropDownActions()}
      </Dropdown>
    )
  }

  render(): JSX.Element {
    if (this.props.downTime.failedAction) {
        return (
          <OverlayTrigger
            placement={'left'}
            overlay={this.failedActionOverlays[this.props.downTime.failedAction.action]}
          >
            {this.renderDropDown()}
          </OverlayTrigger>
        )
    } else {
      return this.renderDropDown()
    }
  }
}

export default DownTimeActionsButton
